module.exports = __webpack_public_path__ + "static/media/5.ff95bed1.JPG";